export default function WhatsApp() {
  return (
    <a
      href="https://wa.me/919884204949"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 p-4 rounded-full shadow-lg hover:scale-110 transition z-50"
    >
      💬
    </a>
  );
}